import { render, staticRenderFns } from "./Qualification.vue?vue&type=template&id=730dbb79&scoped=true&functional=true&"
var script = {}
import style0 from "./Qualification.vue?vue&type=style&index=0&id=730dbb79&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "730dbb79",
  null
  
)

export default component.exports